module.exports = __webpack_public_path__ + "img/munzinger-personen.781b42cd.png";